import React, { useState } from 'react';
import smileLaptop from '../../assets/Landing-Page-Light-Single-BLANK.webp'
import { BiArch } from 'react-icons/bi';
import LandingFooter from './LandingFooter';
import { landJoinUrl } from '../../providers/EnvContextProvider';
import { isValidEmail } from '../../hooks/useValidation';
import LandLine from './LandLine';
import { Link } from 'react-router-dom';
import './LandingPage.css';

// ------  Landing Page  ------
// 
const LandingPage = () => {
  const [email, setEmail] = useState('');
  const [errorInfo,setErrorInfo]      = useState('Please enter a valid email address');
  const [showError, setShowError]     = useState(false);
  const [signUpDone, setSignUpDone]   = useState(); // {username:'moshe+avdiel@gmail.com.edu', passwd: 'blablu-2454-bling-done-23'}

  const onEmailChanged = (e) => {
    setShowError(false);
    const text = e.target.value;
    setEmail(text);
    
    if (isValidEmail(text, true)) {
      setErrorInfo('');
    }
    else {
      setErrorInfo('Please enter a valid email');
    }
  }

  // Land SignUp
  //
  const handleLandSignUp = () => {
    console.log('handleSignUp  Error:',errorInfo);
    
    if (errorInfo !== '') {
      setShowError(true);
      return;
    }

    const code = Array.from(crypto.getRandomValues(new Uint8Array(6))).map(b => (b % 36).toString(36)).join('');
    const accName = 'my-account-'+code;

    fetch(landJoinUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'landAccountName': accName,
        //'accountPlan': 'teamPro',
        'landUsername': email,
        'landEmail': email,
        'campId': 'land-001'
        // 'userPhone': '',
        // 'firstName': 'Friend',
        // 'midName':'',
        // 'lastName':''
      })
    }).then(resp => {
      if (resp.ok) {

        // Google Ads: Conversion Event on Successful SignUp
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17189270506/Fjv5CIeWzdgaEOrnvYRA',
          'value': 1.0,
          'currency': 'ILS',
          'transaction_id': ''
        });

        resp.json().then(doneData => setSignUpDone(doneData));
      }
      else {
        // ... Error 
        console.error('Error SignUp');
      }
    })
  }


  // ---[  Render  ]---
  
  return (
    <div className='landingPage'>
      <div className='imageBase'>
        <img className='landingSmileLaptop' src={smileLaptop} alt='Happy Developer using Laptop' />         
        <LandingFooter />
      </div>
      
      <div className='landingContent'>

        <div className='landingWelcome'>
            <div className='archIcon'>
              <BiArch />
            </div>
            <div className='landingLogo'>
              Kiponos.io
            </div>
        </div>

        <div className='landStartYour'>
            <div className='startYour'>
              <div>Start Real-Time Config Today!</div>
            </div>

            <div className='forgetAboutIt0'>
              <div className='forgetAboutIt1'>configurations?</div>
              <div className='forgetAboutIt2'>Forget About It!</div>
            </div>            
          </div>

          {/* <div className='pioneering'>
            Pioneering true real-time updates<p/>Zero Latency!
          </div> */}

          <div className='landPoints'>
            <i>Modify in Real-Time:</i><p/>
            <ul className='greenCheckLI'>
                <li>i18n</li>
                <li>Feature Flags</li>
                <li>Validation</li>
                <li>Log Levels</li>
                <li>Any Config Item!</li>
            </ul>
          </div>

          <div className='landAboutUs'>
            <div className='landAboutUsTitle'>About Us</div>
            <div className='landAboutUsInfo'>
            Kiponos frees you from config headaches with real-time, restart-free updates—so you can focus on development, save time, and boost productivity.
            <div className='landContact'>
              Hartom 17, Har Hotzvim Industrial Park, Jerusalem, Israel.<br/>
              HelpDesk@kiponos.io  +972-54-4602111
              <div> <a style={{color:'blue'}} href='https://kiponos.io/login'>Kiponos.io</a> </div>
            </div>
            {/* At Kiponos, our mission is simple: eliminate configuration pain for developers and DevOps by delivering real-time, restart-free configuration updates to applications of any scale.<p/>
            Kiponos offers a Config-as-a-Service platform that unifies environments, prevents errors, and boosts productivittyhappiness by letting teams focus on what matters: creating great software.

We believe in a future where no developer wastes time on config files, environment variables, or redeploys. Inspired by sci-fi precision, our platform provides instant delta updates via WebSockets, a sleek control panel, and a revolutionary SDK—empowering teams to build faster, safer, and smarter.

🌍 Kiponos: Making configuration effortless, so humanity can build a better tomorrow.               */}
              {/* Frustrated with endless config files and restarts, we built Kiponos we wish we'd had, so you don't have to struggle. */}
              {/* We make configuration <b>dynamic</b> and <b>instant!</b><br/>
              With virtually <b>zero latency!</b><p/>
              
              Our secured websockets dispatches delta updates only -<br/>
              for both the SDK and Web Admin, providing true real-time<br/>
              to all your environments.<p/>                                                                       */}
            </div>
          </div>

          <div className='landingJoinForm'>
                <div className='inputTitle'>
                  {showError && <div>{errorInfo}</div>} 
                  {!showError && <div>Email</div>}
                </div>
                <input className='landInput' type='text' onChange={onEmailChanged}/>
                <button className='joinNowButton' onClick={handleLandSignUp}>Join Now</button>                
                <hr/>
                <ul>
                  <li>WebSocket Based SDK</li>
                  <li>WebSocket based Web Admin</li>
                  <li>SSL, WSS, JWT Id+Access</li>
                  <li>Role Based Access - Per Team!</li>
                  <li>Highly Encrypted Vault</li>
                  <li>No Restarts, Redeploy, Reload</li>
                  <li>No Refresh - Everything is Instant!</li>
                </ul>
          </div>

          {signUpDone?.username && <div className='landSignUpDone'>
            <div className='landDoneWelcome'>
              Welcome!
            </div>
            <div style={{ fontSize: 14, marginTop: 24, marginBottom: 32}}>Please save your username and password</div>
            {/* <div style={{ fontSize: 14, marginTop: 8, marginBottom: 24}}>And Let's Get Started!</div> */}

            <LandLine title='Username' value={signUpDone.username} />
            <LandLine title='Password' value={signUpDone.passwd} />

            <div className='landLogin'>
              <Link to='/login'>I'm Ready To Login</Link>
            </div>
          </div>}        
      </div>


        {/*<div className='landingSubHeader'>Pioneering real-time config edits — <br/> Update any setting, and your app reacts instantly!</div>*/}      
    </div>
  );
};

export default LandingPage;